var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav navbar-nav main-menu-navigation h-100",attrs:{"id":"main-menu-navigation"}},_vm._l((_vm.items),function(item){return _c(_vm.resolveNavComponent(item),{key:item.header || item.title,tag:"component",staticClass:"d-flex align-items-center",attrs:{"item":item},on:{"update-group-open":_vm.onUpdateGroupOpen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }